
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[idOrSlug]",
      function () {
        return require("private-next-pages/profile/[idOrSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[idOrSlug]"])
      });
    }
  